export default "__VITE_ASSET__D$BeYXg2__"